import { FieldErrors } from 'react-hook-form/dist/types/errors'
import { UseFormRegister } from 'react-hook-form/dist/types/form'

import { EmailPassFormInputs } from '../../../../types/EmailPassFormInputs'
import globalStyles from '../../../../styles/input.module.css'
import { t } from 'i18next'

interface EmailInputProps {
  register: UseFormRegister<EmailPassFormInputs>
  errors: FieldErrors<EmailPassFormInputs>
}

const EmailInput = ({ register, errors }: EmailInputProps) => {
  return (
    <div className={globalStyles.inputGroup}>
      <label htmlFor="email">Email *</label>
      <input {...register('email', { required: true })} type="email" />
      {errors.email && <span>{t('signup.required')}</span>}
    </div>
  )
}

export default EmailInput
